interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "headset 1" asset from the Help menu Figma frame (74159:3232). */
const FigmaHeadsetIcon = ({ width = 20, height = 20, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.1667 13.9625C19.1667 11.8617 18.3608 10.7192 17.2675 10.105C17.1775 4.125 14.9258 1.4525 10 1.4525C5.07417 1.4525 2.81667 4.13083 2.73167 10.1267C1.685 10.735 0.833333 11.8642 0.833333 13.9625C0.833333 18.0375 3.865 18.5083 6.14583 18.5083C6.505 18.5083 6.82333 18.2783 6.93667 17.9367C7.78667 15.3742 7.78667 12.55 6.93667 9.9875C6.82333 9.64667 6.505 9.41583 6.14583 9.41583C5.75083 9.41583 5.11333 9.41583 4.415 9.53917C4.63917 4.23917 6.81667 3.1175 10 3.1175C13.1833 3.1175 15.3617 4.24 15.585 9.5425C15 9.44333 14.405 9.41583 13.8542 9.41583C13.495 9.41583 13.1767 9.64583 13.0633 9.9875C12.3292 12.2017 12.23 14.61 12.7642 16.8775C11.8775 16.8925 11.0283 16.8667 10.2275 16.8017C9.76 16.7675 9.36667 17.1067 9.33 17.5658C9.29333 18.0242 9.635 18.4258 10.0933 18.4633C10.7925 18.5192 11.525 18.5483 12.2842 18.5483C12.8033 18.5483 13.335 18.535 13.8767 18.5083C15.2125 18.5083 19.1667 18.4833 19.1667 13.9625ZM5.53083 16.8275C3.30667 16.7125 2.5 15.9183 2.5 13.9625C2.5 12.0067 3.30667 11.2125 5.53083 11.0975C6.03417 12.965 6.03417 14.9592 5.53083 16.8267V16.8275ZM14.4692 16.8275C13.9658 14.96 13.9658 12.965 14.4692 11.0983C16.6933 11.2133 17.5 12.0075 17.5 13.9633C17.5 15.9192 16.6933 16.7125 14.4692 16.8275Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaHeadsetIcon;
